import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { afterItems, beforeItems } from '../data/transformation';
export function ComparisonSection() {
  return <section className="bg-sand px-4 py-16 md:py-24" data-id="element-48" data-mp="39e7opp9rorsw">
      <Reveal className="mx-auto max-w-5xl" data-id="element-49" data-mp="39coas5bl2sua">
        <div className="overflow-hidden rounded-2xl border border-line bg-white shadow-soft" data-id="element-50" data-mp="34gg0p6c8tptz">
          <div className="grid md:grid-cols-2" data-id="element-51" data-mp="2zh34vw3e98f9">
            <Column eyebrow="IL VECCHIO MODO DI PREPARARE" title="PRIMA" items={beforeItems} positive={false} data-id="element-52" data-mp="2zhwdz3ptsa0k" />
            <Column eyebrow="IL REPERTORIO PRONTO ALL’USO" title="CON PILATES REFORMER PRONTO" items={afterItems} positive data-id="element-53" data-mp="2qgoggnv4vd7j" />
          </div>
        </div>
      </Reveal>
    </section>;
}
interface ColumnProps {
  eyebrow: string;
  title: string;
  items: string[];
  positive: boolean;
}
function Column({
  eyebrow,
  title,
  items,
  positive
}: ColumnProps) {
  const Icon = positive ? CheckIcon : XIcon;
  return <div className={`flex flex-col p-7 md:p-10 ${positive ? 'border-t border-line bg-sage/10 md:border-l md:border-t-0' : 'bg-[#F2F1EF]'}`} data-id="element-54" data-mp="3egya8c96c9dd">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-55" data-mp="30j19r4rlnitf">
        <div data-id="element-56" data-mp="35gt6qd73pv4h">
          <p className={`font-note text-[10px] font-semibold tracking-[0.16em] ${positive ? 'text-sage' : 'text-muted'}`} data-id="element-57" data-mp="35g9vffbyi4zf">
            {eyebrow}
          </p>
          <h3 className="mt-2 font-heading text-xl font-bold leading-tight tracking-tight text-petrol md:text-2xl" data-id="element-58" data-mp="1xzvw85pjke0">
            {title}
          </h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-sage text-white' : 'bg-white text-muted'}`} data-id="element-59" data-mp="3oece7cdwv5os">
          <Icon className="h-5 w-5" strokeWidth={2.5} aria-hidden="true" data-id="element-60" data-mp="fx986wqslucp" />
        </div>
      </div>
      <ul className="space-y-3" data-id="element-61" data-mp="krlx3mb1fxvu">
        {items.map(item => <li key={item} className={`flex items-start gap-3 rounded-xl px-4 py-3.5 ${positive ? 'bg-white' : 'bg-white/70'}`} data-id="element-62" data-mp="ul9bgyehpfa7">
            <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${positive ? 'text-sage' : 'text-muted'}`} strokeWidth={3} aria-hidden="true" data-id="element-63" data-mp="kn24n8dx0dlx" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-petrol' : 'text-muted'}`} data-id="element-64" data-mp="bmnarkmvxq6t">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}